import { h } from 'preact';
import { useMemo, useState } from 'preact/hooks';
import { isValidEmail } from '../utils/helpers';

const BackInStock = ({ currentVariant }) => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState('');
  const [email, setEmail] = useState(
    window.TMW?.customer?.email ? window.TMW?.customer?.email : '',
  );

  const klaviyoKeys = JSON.parse(
    document.querySelector('[data-technical]')?.textContent,
  )?.klaviyo;

  const emailInput = useMemo(
    () => (
      <input
        type={'email'}
        id={'email-input'}
        name={'email'}
        required={true}
        value={email}
        onChange={(e) => handleInputChange(e)}
        className={'mb-5 rounded-[4px]'}
      />
    ),
    [email],
  );

  const handleInputChange = (event) => {
    const { value } = event.target;
    setEmail(value);
  };

  const handleKlaviyo = async (event) => {
    event.preventDefault();
    /* eslint-disable-next-line no-console */
    console.log('formData', {
      email,
      variantId: currentVariant.id,
      type: 'backinstock',
      newsletterId: isSubscribed ? klaviyoKeys.klaviyoSubscribeListId : null,
    });

    if (!isValidEmail(email)) {
      setIsFormInvalid(true);
      setErrorMessageText('Please enter a valid email address.');
      return false;
    }
    setIsFormInvalid(false);
    
    try {
      const response = await fetch(
        // eslint-disable-next-line max-len
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoKeys.klaviyoApiKey}`,
        {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${currentVariant.id.replace(
                      'gid://shopify/ProductVariant/',
                      '',
                    )}`,
                  },
                },
              },
            },
          }),
          method: 'POST',
        },
      );
      if (!response.ok) {
        setIsFormInvalid(true);
        setErrorMessageText(
          'Sorry, something went wrong. Please try again later.',
        );
        throw new Error('Network response was not ok');
      }
      if (isSubscribed) {
        const options = {
          method: 'POST',
          headers: {
            revision: '2023-02-22', // api version?
            'Content-Type': 'application/json',
          },
          // eslint-disable-next-line max-len
          body: `{"data":{"type":"subscription","attributes":{"list_id":"${klaviyoKeys.klaviyoSubscribeListId}","email":"${email}"}}}`,
        };
        const subscriptionResponse = await fetch(
          // eslint-disable-next-line max-len
          `https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoKeys.klaviyoApiKey}`,
          options,
        );
        // eslint-disable-next-line no-console
        console.log(subscriptionResponse);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setIsFormInvalid(true);
      setErrorMessageText(
        'Sorry, something went wrong with subscription. Please try again later.',
      );
    }
    setIsFormSubmitted(true);
    setEmail('');
    setIsSubscribed(false);
    event.target.reset();
    return '';
  };

  return (
    <div className={'flex h-screen flex-col justify-center'}>
      <form
        className={'flex flex-col'}
        onSubmit={handleKlaviyo}
        id="subscribe-form"
        noValidate
      >
        <p className={'subheading-h3 text-black mb-[10px]'}>
          {window.TMW.Strings.backinstock.header.replace('[title]', currentVariant.product.title)}
        </p>
        <p className={'font-13 text-black mb-5'}>
          {window.TMW.Strings.backinstock.subheader}
        </p>
        <label htmlFor="email-input" className={'font-13-bold text-black mb-2'}>
          Your Email
        </label>
        {emailInput}
        <input
            type={'checkbox'}
            id={'subscribe-newsletter'}
            name={'subscribe-newsletter'}
            checked={isSubscribed}
            onChange={() => setIsSubscribed((current) => !current)}
            className='rounded-[4px] hidden peer'
          />
        <label
          htmlFor="subscribe-newsletter"
          className={'text-[#535353] utility-2 mb-5 checkbox peer-checked:after:block'}
        >
          {' '}
          {window.TMW.Strings.backinstock.newsletterSignupMessage}
        </label>
        <button type="submit" className={'btn-primary w-full'}>
          Submit
        </button>
      </form>
      {isFormSubmitted && (
        <div className="font-13 text-left w-full py-5 text-green">
          {window.TMW.Strings.backinstock.signupSuccessMessage}
        </div>
      )}
      {isFormInvalid && (
        <div className="font-13 text-left w-full py-5 text-red">
          {errorMessageText}
        </div>
      )}
    </div>
  );
};

export default BackInStock;
